namespace Ir.Components.Workbook.Widgets._Html.ReportWidgetHtml {
    interface IViewModel {
        config: WorkbookConfig;
        widget: IWidget;

        reportConfig: ReportConfig;
        result: ReportWidgetResultVM;
        dataSource: any[];

        getTableStyle: Function;
        getTableAttr: Function;
    }

    interface IParams {
        config: WorkbookConfig;
        widget: IWidget;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        this.config = params.config as WorkbookConfig;
        this.widget = params.widget;

        this.reportConfig = this.widget.itemConfig as ReportConfig;
        this.result = this.widget.result;
        this.dataSource = getDataSource(this);

        computedStyleToInlineStyle($("report-widget-html").get(0), {
            recursive: true,
            properties: ['font-size', 'text-decoration', 'background-color', 'border-collapse', 'border', 'text-align',
                'font-family', 'font-weight', 'vertical-align', 'padding', 'color'],
        });

        this.getTableStyle = () => {
            let styles = {
            } as any;

            if (self.reportConfig.columnsWidthType() === ColumnsWidthTypeEnum.Percentage) {
                styles.width = "100%";
            }

            return styles;
        };

        this.getTableAttr = () => {
            let styles = {} as any;

            if (self.reportConfig.columnsWidthType() === ColumnsWidthTypeEnum.Percentage) {
                styles.width = "100%";
            }

            return styles;
        };
    }

    function getDataSource(self: IViewModel) {
        let dataSource = self.result.result;
        if (self.result.columns.filter(x => x.isGrouping).length > 0 && self.reportConfig.subtotalsPosition() === TotalsPositionEnum.Bottom) {
            const output: any[] = [];
            let lastSubtotal: any = null;

            self.result.result.forEach((r, i) => {
                if (r[0] === IrUtils.subTotalRowTypeName) {
                    lastSubtotal = r;
                    let newRow = [...r];
                    newRow[0] = IrUtils.subTotalStartRowTypeName;
                    output.push(newRow);
                } else if (r[0] === IrUtils.detailRowTypeName || r[0] === IrUtils.totalRowTypeName) {
                    output.push(r);

                    if (r[0] === IrUtils.detailRowTypeName) {
                        const next = self.result.result[i + 1];
                        if (!next || next[0] === IrUtils.subTotalRowTypeName) {
                            if (lastSubtotal) {
                                output.push([...lastSubtotal]);
                                lastSubtotal = null;
                            }
                        }
                    }
                }
            });

            dataSource = output;
        }

        return dataSource;
    }
}